import { createSelector } from "reselect";

import getPartsState from "./getPartsState";

const getPartsQuery = createSelector(getPartsState, ({ loading }) => loading);

export default getPartsQuery;
